import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import dayjs from 'dayjs';

import { CustomAvatar } from '@app/components/custom-avatar';
import { TableCellCustom } from '@app/components/table';
import { IReview } from '../types';
import { RowActions } from './row-actions';
import { StatusTag, TruncatedTypography } from '@app/components';
import { ReviewStatus } from '@app/constants';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { useAuthRole } from '@app/utils';

interface Props {
  row: IReview;
  selected: boolean;
  onSelectRow: VoidFunction;
  isTLSelected?: boolean;
}

const ReviewRow = (props: Props) => {
  const { row, isTLSelected } = props;
  const { isManager, isSuperAdmin } = useAuthRole();

  const statusMapping: Record<string, ReviewStatus> = {
    Good: ReviewStatus.Good,
    Poor: ReviewStatus.Poor,
    Average: ReviewStatus.Average,
    Excellent: ReviewStatus.Excellent,
    VeryGood: ReviewStatus.VeryGood,
  };

  const navigate = useNavigate();

  const handleDetails = () => {
    navigate(PATH_DASHBOARD.reviewDetail, { state: { row, isTLSelected } });
  };
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const reviewTo = `${row.usersReviewTo?.firstName ?? ''} ${row.usersReviewTo?.lastName ?? ''}`;
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const reviewFrom = `${row.userReviewFrom?.firstName ?? ''} ${row.userReviewFrom?.lastName ?? ''}`;
  const reviewToImage = row?.usersReviewTo?.profileImage;
  const reviewFromImage = row?.userReviewFrom?.profileImage;
  return (
    <>
      <TableCellCustom flex style={{ cursor: 'pointer' }}>
        <Typography>{row.id}</Typography>
      </TableCellCustom>
      {isSuperAdmin && (
        <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
          <Stack style={{ flexDirection: 'row', alignItems: 'center', gap: '9px' }}>
            <CustomAvatar name={reviewFrom} src={reviewFromImage} color="info" />
            <Typography variant="body2">{reviewFrom}</Typography>
          </Stack>
        </TableCellCustom>
      )}
      <TableCellCustom flex align="center" onClick={handleDetails} style={{ cursor: 'pointer' }}>
        <Stack style={{ flexDirection: 'row', alignItems: 'center', gap: '9px' }}>
          <CustomAvatar name={reviewTo} src={reviewToImage} color="info" />
          <Typography variant="body2">{reviewTo}</Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom
        style={{ width: '100px', cursor: 'pointer' }}
        align="center"
        onClick={handleDetails}
      >
        <Typography variant="body2" width={140}>
          {dayjs(row?.createdAt).format(' HH:mm A DD/MM/YYYY ')}
        </Typography>
      </TableCellCustom>
      <TableCellCustom
        style={{ width: '100px', cursor: 'pointer' }}
        align="center"
        onClick={handleDetails}
      >
        <Typography variant="body2"> {row?.behavior}</Typography>
      </TableCellCustom>
      <TableCellCustom
        width={50}
        align="center"
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
      >
        <Typography variant="body2">
          {isManager || !isTLSelected ? row?.taskPerformance : row?.decisionMakingSkills}
        </Typography>
      </TableCellCustom>
      <TableCellCustom
        width={50}
        align="center"
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
      >
        <Typography variant="body2">
          {isManager || !isTLSelected ? row?.projectInvolvement : row?.leadershipSkills}
        </Typography>
      </TableCellCustom>
      <TableCellCustom
        width={50}
        align="center"
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
      >
        <Typography variant="body2">{row?.communicationSkills}</Typography>
      </TableCellCustom>
      <TableCellCustom
        width={50}
        align="center"
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
      >
        <Typography variant="body2">
          {isManager || !isTLSelected ? row?.learningSkills : row?.fairTreatment}
        </Typography>
      </TableCellCustom>
      <TableCellCustom
        width={50}
        align="center"
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
      >
        <Typography variant="body2">{row?.disciplineManners}</Typography>
      </TableCellCustom>
      <TableCellCustom
        width={50}
        align="center"
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
      >
        <StatusTag status={ReviewStatus[statusMapping[row?.overall]]} />
      </TableCellCustom>
      <TableCellCustom onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <TruncatedTypography text={row?.description || 'NA'} width={150} />
      </TableCellCustom>
      <TableCellCustom align="right" width={50} style={{ cursor: 'pointer' }}>
        <RowActions row={row} isTLSelected={isTLSelected} />
      </TableCellCustom>
    </>
  );
};

export { ReviewRow };
